import { combineReducers } from '@reduxjs/toolkit';
import { pageModelReducer } from './page-model';
import { activeRegionReducer } from './active-region';

export const featuresReducer = combineReducers({
    pageModel: pageModelReducer,
    activeRegionId: activeRegionReducer,
});